import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { userHasPermission } from '../../../../../swzutils/UserPermissionsUtil';
import { Button } from "antd";
import { EditOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import PaginatedFilterableTable, {} from "../../../components/table/PaginatedFilterableTable";
import ActiveStatusTag from "../../../components/ActiveStatusTag";
import CustomerGroupUpdateModal from "./CustomerGroupUpdateModal";
import RequireTenantSelection from "../../../components/RequireTenantSelection";
import HasPermissions from "../../../../../containers/HasPermissions";
import { useAppSelector } from "../../../../../store";
import { loggedInUserSelector, selectedTenantSelector } from "../../../../../store/slice/auth";
const CustomerGroupsTable = () => {
    const tableRef = useRef(null);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const selectedTenant = useAppSelector(selectedTenantSelector);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [editCustomerGroup, setEditCustomerGroup] = useState(null);
    const refresh = () => {
        tableRef.current?.fetch();
    };
    const showModal = (customerGroup) => {
        setEditCustomerGroup(customerGroup);
        setShowUpdateModal(true);
    };
    const closeModal = () => {
        setEditCustomerGroup(null);
        setShowUpdateModal(false);
    };
    const closeModalAndRefresh = () => {
        closeModal();
        refresh();
    };
    const columns = [{
            key: 'name',
            title: 'Name',
            dataIndex: 'name',
            width: '80%',
            filter: {
                type: 'text',
                requestKey: 'nameLike',
                placeholder: 'Name',
            }
        }, {
            title: 'Active',
            dataIndex: 'enabled',
            width: '10%',
            filter: {
                type: 'enum',
                requestKey: 'active',
                enums: [{
                        text: 'Active',
                        value: true,
                    }, {
                        text: 'Inactive',
                        value: false,
                    }],
                filterMultiple: false,
            },
            render: (text, record) => (_jsx(ActiveStatusTag, { active: record.active }))
        }, {
            title: 'Action',
            key: 'action',
            width: '10%',
            condition: userHasPermission(loggedInUser, ['admin:customerGroup:update']),
            render: (text, record) => (_jsx("span", { className: "actions", children: _jsx(Button, { onClick: () => showModal(record), icon: _jsx(EditOutlined, {}), children: "Edit" }) }))
        }];
    return (_jsxs(RequireTenantSelection, { children: [_jsxs("div", { className: "table-operations clearfix", children: [_jsx(HasPermissions, { permissions: ['admin:customerGroup:create'], children: _jsx(Button, { onClick: () => showModal(null), title: "Add a Customer Group", icon: _jsx(PlusOutlined, {}), children: "Add a Customer Group" }) }), _jsx(Button, { className: "pull-right", onClick: refresh, title: "Refresh", icon: _jsx(ReloadOutlined, {}) })] }), _jsx(PaginatedFilterableTable, { tableKey: 'customerGroupsTable', ref: tableRef, dataUri: "/admin/v1/customers/groups", columns: columns, initialFilters: {
                    active: [true]
                } }), _jsx(CustomerGroupUpdateModal, { open: showUpdateModal, tenantId: selectedTenant?.id, customerGroup: editCustomerGroup, onCancel: closeModal, onSave: closeModalAndRefresh })] }));
};
export default CustomerGroupsTable;
